import api from '@pray/shared/utils/api';
import type { CatalogListResponse } from './types';

type Props = { artistId: string; q?: string; limit?: number; cursor?: string | null };

export async function getCatalogs({ artistId, q, limit = 25, cursor }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  const params: Record<string, string | number> = { limit };
  if (q) params.q = q;
  if (cursor) params.cursor = cursor;
  // The backend wraps every payload in an envelope ({ responded_at, object, data }),
  // so res.data is the envelope and res.data.data is the actual payload. Unwrap one
  // level here (matching studioService/contentSeries/getSeriesStats.ts) rather than
  // via a global axios interceptor, which would double-unwrap sibling services that
  // already return the raw envelope (e.g. emailCampaigns/getEmailCampaign.js).
  const res = await api.executeGetRequest<{ data: CatalogListResponse }>(
    `/web/studio/artists/${artistId}/catalogs`, params);
  return res.data.data;
}
